import { spacing } from '@rbilabs/universal-components/themes';
import { useIntl } from 'react-intl';
import { View } from 'react-native';

import DrawerPage from 'components/layout/drawer-page';
import { MastercardTile } from 'pages/loyalty/loyalty-partners/mastercard';
import { MntCard } from 'pages/loyalty/loyalty-partners/mnt';
import { WalmartOffer } from 'pages/loyalty/loyalty-partners/walmart/walmart-offer';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'state/launchdarkly/flags';

export default function Partnerships() {
  const { formatMessage } = useIntl();
  const headerText = formatMessage({ id: 'partnerOffers' });

  const showMastercardTile = useFlag(LaunchDarklyFlag.SHOW_MASTERCARD_PARTNERSHIP);

  return (
    <DrawerPage headerText={headerText}>
      <View style={{ gap: spacing.$4 }}>
        <WalmartOffer />
        {showMastercardTile && <MastercardTile />}
        <MntCard />
      </View>
    </DrawerPage>
  );
}
